import {profileCompleteActions} from '../actions';

export default function profileComplete(initialState = {}, action) {
    const newState = {...initialState};
    switch (action.type) {
        case profileCompleteActions.GET_PROFILE_COMPLETE: return getProfileComplete(newState, action);
        case profileCompleteActions.SET_PROFILE_COMPLETE: return setProfileComplete(newState, action);
        case profileCompleteActions.PROFILE_COMPLETE_ERROR: return profileCompleteError(newState, action);
        default: return newState;
    }

}

function getProfileComplete(newState, action) {
    return newState;
}

function setProfileComplete(newState, action) {
    let reducedSections = action.body.values.map((section) => {
        return {
            name : section.name,
            complete: section.complete
        };
    });

    newState = {...newState,
                currentPercentageComplete: action.body.total,
                sections: reducedSections
    };

    return newState;

}

function profileCompleteError(newState, action) {
    return newState;
}





// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/profile-complete.js